import { AtomicStatusType } from '../../graphql/generated';
import { IconName } from '../icons';

export const getIdvStatusProps = (
    status: AtomicStatusType
):
    | { text: string; iconName: IconName; style: 'info' | 'error' }
    | undefined => {
    switch (status) {
        case 'VERIFICATION_PROCESSING':
        case 'VERIFICATION_DENIED':
            // VerificationDenied means the user is on a serious watchlist - we don't want to actually expose to them that verification failed
            return {
                text: 'Verification in progress',
                iconName: 'Clock',
                style: 'info',
            };
        case 'VERIFICATION_FAILED':
            return {
                text: 'Verification failed',
                iconName: 'AlertCircle',
                style: 'error',
            };
        case 'VERIFICATION_NEEDS_DOC_UPLOAD':
            return {
                text: 'Verification needed',
                iconName: 'AlertCircle',
                style: 'error',
            };
        case 'NEEDS_CONSENT':
        case 'NEEDS_ONBOARDING':
        case 'VERIFICATION_SUCCESSFUL':
        case 'ACCOUNT_COMPLETE':
            return;
        default: {
            // eslint-disable-next-line @typescript-eslint/no-unused-vars
            const _exhaustiveCheck: never = status;
        }
    }
};
